import RssFeeds from '../../common/components/rssFeeds';
import CardGroup3 from './cardGroup';

class RssFeeds3 extends RssFeeds {
  constructor() {
    super(...arguments);
    this.cardGroupComponent = CardGroup3;
    // Remove pagination until https://jira.godaddy.com/browse/VNEXT-34831 is fixed which is dependent on
    // https://jira.godaddy.com/browse/VNEXT-35163 (ETA end of 1st quarter 2021)
    // this.paginateFeed = true;
  }
}

export default RssFeeds3;
